import errorMessage from "./errorMessages/errorMessage_en";
import errorMessage_es from "./errorMessages/errorMessages_es";
import errorMessage_fr from "./errorMessages/errorMessages_fr";
import errorMessage_it from "./errorMessages/errorMessages_it";
import errorMessage_pt from "./errorMessages/errorMessages_pt";
import errorMessage_ar from "./errorMessages/errorMessages_ar";
import { getCookie } from "./toasterMessages/showToaster";

const errorMessages = {
    'en': errorMessage,
    'en-US': errorMessage,
    'es': errorMessage_es,
    'fr': errorMessage_fr,
    'fr-FR': errorMessage_fr,
    'it': errorMessage_it,
    'it-IT': errorMessage_it,
    'pt': errorMessage_pt,
    'pt-PT': errorMessage_pt,
    'ar': errorMessage_ar
};

const showErrorMessage = async ({ errorCode, error, language, data }) => {
    let selectedLang, cookieLang;
    cookieLang = getCookie("lang") || 'en';
    selectedLang = language ? language : cookieLang;

    const messages = errorMessages[selectedLang] || errorMessage;

    return await messages(errorCode, error, data);
}
export default showErrorMessage;